import React from 'react';
import styled from 'styled-components'
import {Link} from 'react-router-dom'

const Header = () => {
    return (
        <Nav>

                    <Link to='/'>
                <Logo src="images/logo.svg"/>
                    </Link>

                <NavMenu>
                    <Link to='/'>
                        <img src='/images/home-icon.svg' />
                        <span>Home</span>
                    </Link>
                    <Link to='/toprated'>
                        <img src='/images/search-icon.svg' />
                        <span>Search</span>
                    </Link>
                    <Link to='wishlist'>
                        <img src='/images/watchlist-icon.svg' />
                        <span>Whatlist</span>
                    </Link>
                    <Link to = 'original'>
                        <img src='/images/original-icon.svg' />
                        <span>Original</span>
                    </Link>
                    <Link to='/movies'>
                        <img src='/images/movie-icon.svg' />
                        <span>Movies</span>
                    </Link>
                    <Link to='series'>
                        <img src='/images/series-icon.svg' />
                        <span>Series</span>
                    </Link>
                    <Link to='/login'>
                        <img src='/images/series-icon.svg' />
                        <span>Login</span>
                    </Link>

                </NavMenu>

                    <UserImg src='https://media-exp1.licdn.com/dms/image/C4D03AQGu5EvPgZFWcA/profile-displayphoto-shrink_800_800/0/1653699693592?e=1666224000&v=beta&t=AN1s1xlteUj_MuiHA1VLIJnTYciDCPowUcSLaPISmOY' alt='user' />
                    {/* <UserImg src='/images/bikesh.jpg' alt='user' /> */}

        </Nav>
    );
}

export default Header;

const Nav = styled.div`
overflow-x: hidden;
height: 70px;
background-color: #090b13;
display: flex;
align-items: center;
padding: 0 36px;
`
const Logo = styled.img`
width: 80px;

`

const NavMenu = styled.div`
        display: flex;
        flex: 1;
        margin-left: 25px;
        align-items: center;
        

        a{
            display: flex;
            align-items: center;
            padding: 0 12px;
            cursor: pointer;
            text-decoration:none ;
            color:white ;
        
        img{
            height: 20px;

        }

        span{
            font-size: 14px;
            letter-spacing: 1.42px;
            position: relative;

            &:after{
                content:  "";
                height: 2px;
                background-color: white;
                position: absolute;
                left: 0;
                right: 0;
                bottom: -6px;
                opacity: 0;
                transform-origin: left center;
                transition: all 250ms cubic-bezier(0.55, 0.085, 0.68, 0.53);
                transform: scaleX(0);
                
            }
        }
        &:hover{
            span:after{
                transform: scaleX(1);
                opacity: 1;
            }
        }
    }

`

const UserImg = styled.img`
    width: 48px;
    height: 48px;
    border-radius: 50%;
    cursor: pointer;
    object-fit: cover;

    background-color: white;


`